module.exports = __webpack_public_path__ + "img/ic_process_authorize.00ceb789.png";